// Resolves the TRIYO web application URL the add-in navigates the user to
// (Launch TRIYO, Open in TRIYO, dashboard/task deep links). Prefers the
// dedicated `launchUrl` setting and falls back to `appUrl`, so a deployment
// whose user-facing web app lives on a different host than the auth/SSO domain
// can point them apart. Returns "" when neither is configured.
export function resolveLaunchUrl(path = ""): string {
  const base = window.APP_SETTINGS?.launchUrl || window.APP_SETTINGS?.appUrl || "";
  if (!base) return "";

  const root = base.endsWith("/") ? base : `${base}/`;
  if (!path) return root;
  return new URL(path.replace(/^\/+/, ""), root).toString();
}
